module.exports = __webpack_public_path__ + "img/start-task.91ee679b.svg";